<template>
    <RouterView v-slot="{ Component }">
        <template v-if="Component">
            <Transition
                enter-active-class="duration-300 ease-out"
                enter-from-class="opacity-0"
                enter-to-class="opacity-100"
                leave-active-class="duration-200 ease-in"
                leave-from-class="opacity-100"
                leave-to-class="opacity-0"
                appear
            >
                <Suspense>
                    <template #default>
                        <!-- main content -->
                        <component :is="Component" />
                    </template>

                    <template #fallback>
                        <!-- loading state -->
                        <div class="w-full h-full flex flex-col items-center justify-center">
                            <LoadingSpinner />
                        </div>
                    </template>
                </Suspense>
            </Transition>
        </template>
    </RouterView>
    <SnackbarPortal />
</template>

<script setup lang="ts">
    import { onErrorCaptured, provide } from 'vue'
    import LoadingSpinner from '@/components/elements/LoadingSpinner.vue'
    import { SnackbarPortal, useSnackbar } from '@tapp.online/ui'

    onErrorCaptured((e, instance, info) => {
        console.log(e, instance, info)
    })

    const { setSnackbarConfig } = useSnackbar()
    provide('snackbar', useSnackbar())

    // Default configuration
    setSnackbarConfig({
        reverse: false, // Set to true to reverse the order of the snackbars
        duration: 2000, // In ms. Set to 0 to make snackbars sticky
        maxSnackbars: 5,
        closeOnClick: true,
        pauseOnHover: true // Snackbar won't disappear while hovered
    })
</script>
